export default {
  defaultStyle: {
    '&:lang(ar)': {
      direction: 'rtl'
    }
  },
  vShape: {
    width: "30px",
    height: "13px",
    marginRight: "10px",
    '&:before': {
      content: "'\\e052'",
      fontFamily: 'Icons',
      fontSize: '13px',
      width: '20px',
      height: '13px',
      position: 'relative',
      display: 'inline-block',
      WebkitTextStroke: '1px #fff',
      textStroke: '1px #fff',
      transition: 'transform 0.2s ease'
    }
  },
  vShapeReverse: {
    '&:before': {
      transform: "rotate(180deg)"
    }
  },
  moreRatesToggle: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    cursor: 'pointer',
    '@media(min-width:902px)': {
      marginBottom: '5px'
    }
  },
  hidden:{
    display:"none"
  },
  boardTitle: {
    fontSize: '16px',
    padding: '3px 5px 3px 0px',
    position: 'relative',
    width: '25%',
    display: 'table-cell',
    verticalAlign: 'middle',
    textTransform: 'uppercase',
    height: '60px',
    boxSizing:'border-box',
    '& > span:last-of-type': {
      outline: 'none',
      display: 'inline',
      textAlign: 'left',
      fontSize: '15px',
      marginRight: '11px',
      fontWeight: '400',
      '@media(min-width:901px)': {
        fontSize: '18px'
      },
      '&:lang(ar)': {
        textAlign: "right",
        marginRight: "0",
        marginLeft: "11px"
      }
    },
    '&:lang(ar)': {
      paddingRight: "13px",
      paddingLeft: "5px",
      textAlign: "right"
    },
    '&:has($vShape)': {
      verticalAlign: 'top',
      paddingTop: '22px',
      lineHeight: '30px'
    }
  },
  singleRate: {
    width: '100%',
    position: 'relative',
    padding: '0',
    '& $boardTitle': {
      '&:lang(ar)': {
        '&:after': {
          left: "auto",
          right: "100%",
          borderLeft: "none",
        }
      },
      '@supports (-ms-accelerator:true)': {
        '&:after': {
          top: '0',
          marginTop: '5px'
        }
      },
      '@media (max-width:901px)': {
        padding: '5px 0px',
        display: 'block',
        width: 'auto',
        height: 'auto',
        fontSize: '13px',
        borderBottom: '0.5px solid #d8d8d8',
      }
    },
    '& ul': {
      display: 'table-cell',
      verticalAlign: 'middle',
      '@media (max-width:901px)': {
        width: 'auto',
        display: 'block'
      },
      '& li': {
        display: 'table',
        width: '100%',
        position: 'relative',
        padding: '5px 0',
        '&:last-of-type': {
          border: '0',
          marginBottom: '0'
        },
        '&:not(:last-of-type)': {
          marginBottom: '0',
          paddingBottom: '8px',
          '&:after': {
            content: "''",
            position: 'absolute',
            left: '15px',
            bottom: '0',
            right: '0',
            borderTop: '1px solid #d2d2d2',
            '@media (max-width:901px)': {
              left: '0'
            }
          },
          '&:lang(ar)': {
            '&:after': {
              left: 0,
              right: '15px',
              '@media (max-width:901px)': {
                right: '0',
              }
            }
          }
        }
      }
    },
    '@media (min-width:901px)': {
      display: 'table'
    }
  },
  doubleRate: {
    display: 'table',
    width: '100%',
    position: 'relative',
    padding: '0',
    '& $boardTitle': {
      '&:lang(ar)': {
        '&:after': {
          left: "auto",
          right: "100%",
          borderLeft: "none",
        }
      },
      '@supports (-ms-accelerator:true)': {
        '&:after': {
          top: '0',
          marginTop: '0'
        }
      },
      '@media (max-width:901px)': {
        padding: '5px 0',
        display: 'block',
        width: 'auto',
        height: 'auto',
        fontSize: '13px',
        borderBottom: '0.5px solid #d8d8d8',
      }
    },
    '& ul': {
      '@media (max-width:901px)': {
        width: 'auto',
        display: 'block'
      },
      '& li': {
        position: 'relative',
        padding: '5px 0',
      },
      '& li:not(:last-of-type)': {
        //marginBottom: '8px',
        paddingBottom: '8px',
        '@media (max-width:901px)': {
          marginBottom: '0px',
          //paddingBottom: '0px'

        },
        '&:lang(ar)': {
          '&:after': {
            left: "0",
            right: "15px",
            '@media (max-width:901px)': {
              right: "0"
            }
          }
        }
      }
    }
  },
  boardTooltip: {
    textAlign: 'center',
    textTransform: 'uppercase',
    position: 'absolute',
    maxWidth: '200px',
    display: 'table',
    backgroundColor: '#fc0',
    font: "11px 'Roboto', sans-serif",
    color: '#333',
    padding: '20px 15px',
    zIndex: '700',
    '@media (max-width:600px)': {
      paddingTop: '25px'
    }
  },
  boardInfo: {
    textAlign: 'center',
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: '16px'
  },
  withBorder: {
    borderBottom: '1px solid #D8D8D8'
  },
  hotelSelection: {
    padding: '0 !important'
  },
  tooltipPointerStyle: {
    backgroundColor: '#fc0',
    width: '10px',
    height: '10px'
  }
};
